// DatabaseContext.js — active collection context (product noun: Collection; wire: databaseKey)
import React, { createContext, useContext, useMemo, useState } from 'react';

export const DatabaseContext = createContext();

/** @deprecated Prefer CollectionContext — alias during Ai vocabulary migration. */
export const CollectionContext = DatabaseContext;

export const useDatabase = () => {
  const context = useContext(DatabaseContext);

  if (!context) {
    throw new Error('useDatabase must be used within a DatabaseProvider');
  }

  return context;
};

/** Product alias for useDatabase (Ai vocabulary: Collection). */
export const useCollection = () => {
  const context = useContext(DatabaseContext);

  if (!context) {
    throw new Error('useCollection must be used within a CollectionProvider (or DatabaseProvider)');
  }

  return context;
};

export const DatabaseProvider = ({ children }) => {

  const [activeDatabase, setActiveDatabase] = useState(null);
  const [lastViewKeyByDatabase, setLastViewKeyByDatabase] = useState({});

  const value = useMemo(() => ({
    activeDatabase,
    setActiveDatabase,
    lastViewKeyByDatabase,
    setLastViewKeyByDatabase,
    // Product aliases — same references; persistence still uses databaseKey.
    activeCollection: activeDatabase,
    setActiveCollection: setActiveDatabase,
    lastViewKeyByCollection: lastViewKeyByDatabase,
    setLastViewKeyByCollection: setLastViewKeyByDatabase,
  }), [activeDatabase, lastViewKeyByDatabase]);

  return (
    <DatabaseContext.Provider value={value}>
      {children}
    </DatabaseContext.Provider>
  );
};

/** Product alias for DatabaseProvider. */
export const CollectionProvider = DatabaseProvider;
